export default __webpack_public_path__ + "static/media/noAddons.86483850.svg";